import { keepPreviousData, useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getPartnerTransactions } from '@apis/partner';
import type { PageResponse } from '@models/api';
import type { PartnerTransaction } from '@models/partner';

type Params = {
  partnerId: number;
  page: number;
  pageSize: number;
};

export const usePartnerTransactions = ({ partnerId, page, pageSize }: Params) => {
  const queryOptions: UseQueryOptions<PageResponse<PartnerTransaction>, Error> = {
    // Keep cache keys consistent and include pagination params.
    queryKey: ['partnerTransactions', partnerId, page, pageSize],
    queryFn: () =>
      getPartnerTransactions(partnerId, {
        pageNo: page,
        pageSize,
      }),
    enabled: Boolean(partnerId),
    placeholderData: keepPreviousData,
  };

  return useQuery(queryOptions);
};
